import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { ICampaignListContainer } from "../../features/Campaigns/interface/shared";
import { IMetaCampaign } from "../../features/Campaigns/interface/metaAds";
import { useAuth } from "../helper/useAuth";
import dayjs from "dayjs";

interface UseMetaAdsCampaignsParams {
  startDate?: Date;
  endDate?: Date;
  search?: string;
  status?: string;
  page?: number;
  per_page?: number;
  sort_by?: string;
  sort_order?: "asc" | "desc";
}

export const useMetaAdsCampaigns = (params?: UseMetaAdsCampaignsParams) => {
  const { selectedIntegration } = useAuth();
  const startDate = params?.startDate;
  const endDate = params?.endDate;
  const page = params?.page || 1;
  const per_page = params?.per_page || 10;
  const sort_by = params?.sort_by;
  const sort_order = params?.sort_order;

  return useQuery<ICampaignListContainer<IMetaCampaign>, Error>({
    queryKey: [
      "meta-campaigns",
      startDate?.toISOString(),
      endDate?.toISOString(),
      params?.search,
      params?.status,
      page,
      per_page,
      sort_by,
      sort_order,
      selectedIntegration?.value,
    ],
    queryFn: async () => {
      const queryParams = {
        page,
        per_page,
        ...(startDate && { start_date: dayjs(startDate).format("YYYY-MM-DD") }),
        ...(endDate && { end_date: dayjs(endDate).format("YYYY-MM-DD") }),
        ...(params?.search && { search: params.search }),
        ...(params?.status && { status: params.status }),
        ...(sort_by && { sort_by }),
        ...(sort_order && { sort_order }),
        tracking_id: selectedIntegration?.value as string,
      };

      return httpService.get<ICampaignListContainer<IMetaCampaign>>(
        API_CONFIG.path.metaAdsCampaigns,
        queryParams,
      );
    },
    enabled: !!selectedIntegration?.value,
    placeholderData: (previousData) => previousData,
  });
};
